<template>
  <div class="admin-permissions p-0">
    <b-loading :is-full-page="false" v-model="isLoading"></b-loading>

    <div v-if="permission && permission.admin" class="panel is-danger">
      <p class="panel-heading">Admin Panel</p>

      <section class="create-permission">
        <p class="has-text-left is-size-4 mb-5 has-text-success-dark">
          Add permission
        </p>
        <ValidationObserver v-slot="{ handleSubmit }" ref="form">
          <form @submit.prevent="handleSubmit(createPermission)">
            <ValidationObserver v-slot="{ handleSubmit }">
              <form @submit.prevent="handleSubmit(createPermission)">
                <div
                  class="is-flex is-align-content-center is-justify-content-space-between"
                >
                  <ValidationProvider
                    rules="required|max:30"
                    v-slot="{ errors }"
                    name="Username"
                  >
                    <b-field
                      label="Username"
                      label-position="on-border"
                      :type="errors.length ? 'is-danger' : ''"
                      :message="errors.length ? errors[0] : ''"
                    >
                      <b-input
                        placeholder="Username"
                        v-model="username"
                      ></b-input>
                    </b-field>
                  </ValidationProvider>

                  <div class="is-flex">
                    <ValidationProvider
                      name="Create Tournament"
                      class="is-flex ml-2"
                    >
                      <b-field class="is-flex">
                        <b-checkbox v-model="formProps.createTournament">
                          Create tournament
                        </b-checkbox>
                      </b-field>
                    </ValidationProvider>
                    <ValidationProvider name="Host Simul" class="is-flex ml-2">
                      <b-field class="is-flex">
                        <b-checkbox v-model="formProps.hostSimul">
                          Host Simul
                        </b-checkbox>
                      </b-field>
                    </ValidationProvider>
                  </div>

                  <div class="is-flex mr-2">
                    <b-button
                      native-type="submit"
                      label="Create"
                      type="is-primary"
                      :loading="isLoading"
                    />
                  </div>
                </div>
              </form>
            </ValidationObserver>
          </form>
        </ValidationObserver>

        <p class="has-text-left is-size-4 mt-5 mb-3 has-text-success-dark">
          All permissions ({{ permissions.length }})
        </p>
      </section>

      <section class="permission-table">
        <PermissionTable />
      </section>
    </div>
  </div>
</template>

<script>
import { firestore } from "@/services/firebase";
import { mapGetters } from "vuex";
import PermissionTable from "@/components/admins/PermissionTable.vue";

const permissions = firestore.collection("permissions");

export default {
  components: { PermissionTable },

  name: "AdminPermissions",

  title() {
    return "Permissions";
  },

  data() {
    return {
      isLoading: true,
      permissions: [],
      username: "",
      formProps: {
        createTournament: false,
        hostSimul: false,
      },
    };
  },

  computed: {
    ...mapGetters({
      permission: "getPermission",
    }),
  },

  watch: {
    permission: {
      immediate: true,
      deep: true,
      async handler() {
        if (!this.permission) {
          return;
        }

        if (!this.permission.admin) {
          this.$router.replace({ name: "home" });
          return;
        }

        await this.$bind(
          "permissions",
          permissions.where("admin", "==", false)
        );

        this.isLoading = false;
      },
    },
  },

  methods: {
    async createPermission() {
      this.isLoading = true;
      await permissions.doc(this.username).set({
        admin: false,
        ...this.formProps,
      });

      this.username = "";
      this.formProps = {};
      this.$refs.form.reset();
      this.isLoading = false;
    },
  },
};
</script>

<style scoped>
.create-permission {
  padding: 14px 20px;
}
.permission-table {
  padding: 0 10px;
}
</style>
